import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_BASE_URL } from 'config';

const baseUrl = API_BASE_URL;

export const poucherApi = createApi({
  baseQuery: fetchBaseQuery({ baseUrl }),
  tagTypes: [
    'Hunt',
    'Treasure',
    'Auth',
    'TreasuresLeft',
    'Profile',
    'Settings',
    'Subscription',
    'Favorite',
    'HuntMembers',
    'Invite',
    'Notification',
    'MapOverlay',
  ],
  endpoints: () => ({}),
});
